// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__28yjB","description":"MealItem_description__2g1h7","price":"MealItem_price__3358Z"};